import Cover from "../../components/Cover/Cover";
import coverImage from "../../assets/images/mainCoverImage.webp";
import "./AboutPastoralPage.css";
import coverImageMobile from "../../assets/images/mainCoverImageMobile.webp";
import aboutPastoralImageOne from "../../assets/images/aboutPastoralImageOne.webp";
import aboutPastoralImageTwo from "../../assets/images/aboutPastoralImageTwo.webp";
import aboutPastoralImageThree from "../../assets/images/aboutPastoralImageThree.webp";
import aboutPastoralGarantieImage from "../../assets/images/aboutPastoralGarantieImage.webp";


const AboutPastoralPage = () => {
  const isMobile = window.innerWidth <= 1199;
  const coverImageToUse = isMobile ? coverImageMobile : coverImage;
  return (
    <div className="page">
       <title>Про ТМ «Pastoral» — французькі традиції у кожній краплині молока</title>
       <meta name="description" content={"Дізнайтесь більше про ТМ «Pastoral» — бренд преміальних молочних продуктів, створених за французькими традиціями. Справжнє вершкове масло, сметана, вершки, сиркові десерти та крем-сири з натурального молока найвищої якості."}/>
      <Cover text={"“Pastoral” - Французькі традиції"} src={coverImageToUse} />
      <section className="about__pastoral-production">
        <div className="about__pastoral-production-wrapper">
          <div className="about__pastoral-production-texts">
            <h1 className="about__pastoral-production-title mont-m">
              Bonjour від ТМ “Pastoral”
            </h1>
            <p className="about__pastoral-production-text int-r-21">
              Сердечно вітаємо вас на нашій сторінці — у мезоніні автентичних і
              преміальних молочних продуктів. Ми хочемо запропонувати вам
              справжнє à la carte. ТМ «Pastoral» — це найкращі молочні продукти,
              виготовлені за французькими традиціями. Технологи нашого заводу
              орієнтуються на французькі рецептури й новинки, регулярно
              відвідують інноваційні форуми в Європі, використовують європейські
              закваски та сучасне обладнання.
            </p>
          </div>
          <img
            src={aboutPastoralImageOne}
            alt="Виробництво Миколаївмолпром"
            className="about__pastoral-production-image"
          />
        </div>
        <div className="about__pastoral-production-wrapper reversed">
          <div className="about__pastoral-production-texts">
            <h3 className="about__pastoral-production-subtitle mont-m">
              Pastoral — французька молочна культура{" "}
            </h3>
            <p className="about__pastoral-production-text int-r-21">
              Франція — країна-лідер серед молочних брендів. Це культура, яка
              формувалася століттями, і сенс якої — дарувати насолоду та
              вишуканість. Бренд Pastoral надихається французькою молочною
              культурою та її продуктами — справжнім вершковим маслом, жирними
              вершками, густою сметаною, сирковими десертами, крем-сирами й
              сирами. І ми створюємо такі продукти в Україні.
            </p>
            <p className="about__pastoral-production-text int-r-21">
              З чашкою молока Pastoral на вашій кухні виникає справжня сільська
              ідилія: залиті сонцем поля, де пасуться корівки, а пастушки
              безтурботно насолоджуються життям.
            </p>
          </div>
          <img
            src={aboutPastoralImageTwo}
            alt="Виробництво Миколаївмолпром"
            className="about__pastoral-production-image two"
          />
        </div>
        <div className="about__pastoral-production-wrapper">
          <div className="about__pastoral-production-texts">
            <h3 className="about__pastoral-production-subtitle mont-m">
              Pastoral — гастрономічні шедеври
            </h3>
            <p className="about__pastoral-production-text int-r-21">
              А шматочок хрусткого багета з вершковим золотистим маслом — це вже
              ранок десь під Ейфелевою вежею.
            </p>
            <p className="about__pastoral-production-text int-r-21">
              Ніжний кисломолочний сир підходить для вишуканих десертів і
              тістечок — саме таких, які подають у найкращих ресторанах Франції.
              А густа сметана та вершки — ідеальні для приготування соусів,
              кремів чи сирного супу. І стає тепло на душі. Кажуть: «Мій дім —
              моя фортеця». А ми віримо, що ваш дім — це мезонін, де з ТМ
              “Pastoral” на звичайній кухні народжуються гастрономічні шедеври
              для рідних.
            </p>
          </div>
          <img
            src={aboutPastoralImageThree}
            alt="Виробництво Миколаївмолпром"
            className="about__pastoral-production-image three"
          />
        </div>
      </section>
      <section className="about__pastoral-garantie">
        <div className="about__pastoral-garantie-wrapper">
            <img src={aboutPastoralGarantieImage} alt="Якість Пасторал" className="about__pastoral-garantie-image" />
            <div className="about__pastoral-garantie-texts">
            <h2 className="about__pastoral-production-subtitle mont-m">100% Garantie від ТМ «Pastoral»</h2>
            <p className="about__pastoral-production-text int-r-21">
            Ми впевнені у якості наших молочних продуктів, тому надаємо 100% Garantie / ГАРАНТІЮ.
            </p>
            <p className="about__pastoral-production-text int-r-21">
            Ми гарантуємо якість, бо:
            </p>
            <p className="about__pastoral-production-text bullet int-r-21">
            Уся продукція виготовляється зі 100% натурального молока, отриманого від ретельно перевірених господарств;
            </p>
            <p className="about__pastoral-production-text bullet int-r-21">
            Виробництво ведеться на сучасному європейському обладнанні, під постійним контролем технологів і відділу якості;
            </p>
            <p className="about__pastoral-production-text bullet int-r-21">
            Ми дотримуємося міжнародних стандартів безпечності харчової продукції (ISO 22000:2007);
            </p>
            <p className="about__pastoral-production-text bullet int-r-21">
            Кожна партія проходить додаткову перевірку перед відправкою в магазини.
            </p>
            </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPastoralPage;
